import { UrlMatchResult, UrlSegment } from '@angular/router';

export const errorRouteMatcher = (urlSegments: UrlSegment[]): UrlMatchResult | null => {
	if (urlSegments?.length > 0 && urlSegments?.findIndex(v => v.path === 'error') !== -1) {
		return { consumed: urlSegments } as UrlMatchResult;
	}

	return null;
};
